export default [
  {
    path: "/Company/Index",
    name: "CompanyIndex",
    component: () => import("@/components/Company/Index.vue"),
    meta: {
      name: "CompanyIndex",
      menuTitle: "Company",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Company/Editor",
    name: "CompanyEditor",
    component: () => import("@/components/Company/Editor.vue"),
    meta: {
      name: "CompanyEditor",
      menuTitle: "Company",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Pending/Index",
    name: "PendingIndex",
    component: () => import("@/components/AdminCompany/Pending/Index.vue"),
    meta: {
      name: "PendingIndex",
      menuTitle: "Pending",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Pending/Editor",
    name: "PendingEditor",
    component: () => import("@/components/AdminCompany/Pending/Editor.vue"),
    meta: {
      name: "PendingEditor",
      menuTitle: "Pending",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/CompanyProfile/Index",
    name: "CompanyProfileIndex",
    component: () =>
      import("@/components/AdminCompany/CompanyProfile/Index.vue"),
    meta: {
      name: "CompanyProfileIndex",
      menuTitle: "Company Profile",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/PermitMatrix/Index",
    name: "PermitMatrixIndex",
    component: () =>
      import("@/components/AdminCompany/Matrix/Permit/Index.vue"),
    meta: {
      name: "PermitMatrixIndex",
      menuTitle: "Permit Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/PermitMatrix/Editor",
    name: "PermitMatrixEditor",
    component: () =>
      import("@/components/AdminCompany/Matrix/Permit/Editor.vue"),
    meta: {
      name: "PermitMatrixEditor",
      menuTitle: "Permit Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Sop/Index",
    name: "SopIndex",
    component: () => import("@/components/AdminCompany/Sop/Index.vue"),
    meta: {
      name: "SopIndex",
      menuTitle: "SOP",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Sop/Editor",
    name: "SopEditor",
    component: () => import("@/components/AdminCompany/Sop/Editor.vue"),
    meta: {
      name: "SopEditor",
      menuTitle: "SOP",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/WorkMatrix/Index",
    name: "WorkMatrixIndex",
    component: () => import("@/components/AdminCompany/Matrix/Work/Index.vue"),
    meta: {
      name: "WorkMatrixIndex",
      menuTitle: "Work Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/WorkMatrix/Editor",
    name: "WorkMatrixEditor",
    component: () => import("@/components/AdminCompany/Matrix/Work/Editor.vue"),
    meta: {
      name: "WorkMatrixEditor",
      menuTitle: "Work Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Agt/Index",
    name: "AgtIndex",
    component: () => import("@/components/AdminCompany/Agt/Index.vue"),
    meta: {
      name: "AgtIndex",
      menuTitle: "AGT Person",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Agt/Editor",
    name: "AgtEditor",
    component: () => import("@/components/AdminCompany/Agt/Editor.vue"),
    meta: {
      name: "AgtEditor",
      menuTitle: "AGT Person",
      requiresAuth: true,
    },
    props: true,
  },
   {
    path: "/Aesp/Index",
    name: "AespIndex",
    component: () => import("@/components/AdminCompany/Aesp/Index.vue"),
    meta: {
      name: "AespIndex",
      menuTitle: "AESP Person",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Aesp/Editor",
    name: "AespEditor",
    component: () => import("@/components/AdminCompany/Aesp/Editor.vue"),
    meta: {
      name: "AespEditor",
      menuTitle: "AESP Person",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Lookup/Index",
    name: "LookupIndex",
    component: () => import("@/components/Lookup/Index.vue"),
    meta: {
      name: "LookupIndex",
      menuTitle: "Lookup",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Lookup/Editor",
    name: "LookupEditor",
    component: () => import("@/components/Lookup/Editor.vue"),
    meta: {
      name: "LookupEditor",
      menuTitle: "Lookup",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Country/Index",
    name: "CountryIndex",
    component: () => import("@/components/Country/Index.vue"),
    meta: {
      name: "CountryIndex",
      menuTitle: "Country",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Country/Editor",
    name: "CountryEditor",
    component: () => import("@/components/Country/Editor.vue"),
    meta: {
      name: "CountryEditor",
      menuTitle: "Country",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/CategoryPermit/Index",
    name: "CategoryPermitIndex",
    component: () => import("@/components/CategoryPermit/Index.vue"),
    meta: {
      name: "CategoryPermitIndex",
      menuTitle: "CategoryPermit",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/CategoryPermit/Editor",
    name: "CategoryPermitEditor",
    component: () => import("@/components/CategoryPermit/Editor.vue"),
    meta: {
      name: "CategoryPermitEditor",
      menuTitle: "CategoryPermit",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Role/Index",
    name: "RoleIndex",
    component: () => import("@/components/Role/Index.vue"),
    meta: {
      name: "RoleIndex",
      menuTitle: "Role",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Role/Editor",
    name: "RoleEditor",
    component: () => import("@/components/Role/Editor.vue"),
    meta: {
      name: "RoleEditor",
      menuTitle: "Role",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/MtcType/Index",
    name: "MtcTypeIndex",
    component: () => import("@/components/MtcType/Index.vue"),
    meta: {
      name: "MtcTypeIndex",
      menuTitle: "MtcType",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/MtcType/Editor",
    name: "MtcTypeEditor",
    component: () => import("@/components/MtcType/Editor.vue"),
    meta: {
      name: "MtcTypeEditor",
      menuTitle: "MtcType",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Tool/Index",
    name: "ToolIndex",
    component: () => import("@/components/Tool/Index.vue"),
    meta: {
      name: "ToolIndex",
      menuTitle: "Tool",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Tool/Editor",
    name: "ToolEditor",
    component: () => import("@/components/Tool/Editor.vue"),
    meta: {
      name: "ToolEditor",
      menuTitle: "Tool",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Risk/Index",
    name: "RiskIndex",
    component: () => import("@/components/Risk/Index.vue"),
    meta: {
      name: "RiskIndex",
      menuTitle: "Risk",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Risk/Editor",
    name: "RiskEditor",
    component: () => import("@/components/Risk/Editor.vue"),
    meta: {
      name: "RiskEditor",
      menuTitle: "Risk",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Changelog/Index",
    name: "ChangelogIndex",
    component: () => import("@/components/Changelog/Index.vue"),
    meta: {
      name: "ChangelogIndex",
      menuTitle: "Changelog",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Changelog/Editor",
    name: "ChangelogEditor",
    component: () => import("@/components/Changelog/Editor.vue"),
    meta: {
      name: "ChangelogEditor",
      menuTitle: "Changelog",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/RoleSpv/Index",
    name: "RoleSpvIndex",
    component: () => import("@/components/RoleSpv/Index.vue"),
    meta: {
      name: "RoleSpvIndex",
      menuTitle: "RoleSpv",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/RoleSpv/Editor",
    name: "RoleSpvEditor",
    component: () => import("@/components/RoleSpv/Editor.vue"),
    meta: {
      name: "RoleSpvEditor",
      menuTitle: "RoleSpv",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Checklist/Index",
    name: "ChecklistIndex",
    component: () => import("@/components/Checklist/Index.vue"),
    meta: {
      name: "ChecklistIndex",
      menuTitle: "Checklist",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Checklist/Editor",
    name: "ChecklistEditor",
    component: () => import("@/components/Checklist/Editor.vue"),
    meta: {
      name: "ChecklistEditor",
      menuTitle: "Checklist",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/ApprovalMatrix/Index",
    name: "ApprovalMatrixIndex",
    component: () => import("@/components/ApprovalMatrix/Index.vue"),
    meta: {
      name: "ApprovalMatrixIndex",
      menuTitle: "Approval Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/ApprovalMatrix/Editor",
    name: "ApprovalMatrixEditor",
    component: () => import("@/components/ApprovalMatrix/Editor.vue"),
    meta: {
      name: "ApprovalMatrixEditor",
      menuTitle: "Approval Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/RunningNumber/Index",
    name: "RunningNumberIndex",
    component: () => import("@/components/RunningNumber/Index.vue"),
    meta: {
      name: "RunningNumberIndex",
      menuTitle: "Running Number",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/RunningNumber/Editor",
    name: "RunningNumberEditor",
    component: () => import("@/components/RunningNumber/Editor.vue"),
    meta: {
      name: "RunningNumberEditor",
      menuTitle: "Running Number",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Department/Index",
    name: "DepartmentIndex",
    component: () => import("@/components/Department/Index.vue"),
    meta: {
      name: "DepartmentIndex",
      menuTitle: "Department",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Department/Editor",
    name: "DepartmentEditor",
    component: () => import("@/components/Department/Editor.vue"),
    meta: {
      name: "DepartmentEditor",
      menuTitle: "Department",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/StorageLocation/Editor",
    name: "StorageLocationEditor",
    component: () => import("@/components/StorageLocation/Editor.vue"),
    meta: {
      name: "StorageLocationEditor",
      menuTitle: "Storage Location",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/ReleaseMatrix/Index",
    name: "ReleaseMatrixIndex",
    component: () => import("@/components/ReleaseMatrix/Index.vue"),
    meta: {
      name: "ReleaseMatrixIndex",
      menuTitle: "Release Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/ReleaseMatrix/Editor",
    name: "ReleaseMatrixEditor",
    component: () => import("@/components/ReleaseMatrix/Editor.vue"),
    meta: {
      name: "ReleaseMatrixEditor",
      menuTitle: "Release Matrix",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/Handover/Index",
    name: "HandoverIndex",
    component: () => import("@/components/Handover/Index.vue"),
    meta: {
      name: "HandoverIndex",
      menuTitle: "Hand Over",
      requiresAuth: true,
    },
    props: true,
  },
];
